import { Star } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { MapleMarketApp } from '@/data/mapleMarketApps';

interface RatingsTabProps {
  product: MapleMarketApp;
}

export default function RatingsTab({ product }: RatingsTabProps) {
  const breakdown = [5, 4, 3, 2, 1].map((stars, index) => {
    const weights = [0.58, 0.21, 0.11, 0.06, 0.04];
    return {
      stars,
      percent: Math.max(1, Math.round(weights[index] * 100)),
    };
  });

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-foreground">Ratings summary</h3>
        <p className="text-sm text-muted-foreground">Review metrics are read-only in this first embedded admin release.</p>
      </div>

      <div className="grid gap-6 lg:grid-cols-[280px_1fr]">
        <Card>
          <CardHeader>
            <CardTitle>Overall score</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-center">
            <div className="text-5xl font-bold text-foreground">{product.rating.toFixed(1)}</div>
            <div className="flex items-center justify-center gap-1 text-amber-500">
              {Array.from({ length: 5 }).map((_, index) => (
                <Star
                  key={index}
                  className={`h-4 w-4 ${index < Math.round(product.rating) ? 'fill-current' : ''}`}
                />
              ))}
            </div>
            <div className="text-sm text-muted-foreground">{product.reviews.toLocaleString()} reviews</div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Distribution</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {breakdown.map((row) => (
              <div key={row.stars} className="grid grid-cols-[50px_1fr_50px] items-center gap-3 text-sm">
                <div className="font-medium text-foreground">{row.stars} star</div>
                <div className="h-2 rounded-full bg-muted">
                  <div className="h-2 rounded-full bg-primary" style={{ width: `${row.percent}%` }} />
                </div>
                <div className="text-right text-muted-foreground">{row.percent}%</div>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
